import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { fitYes, fitNo } from '../data/content';

const { FiCheck, FiX } = FiIcons;

function Column({ title, items, icon, color }) {
  return (
    <article className="rounded-2xl border border-gray-200 bg-white p-6">
      <h3 className="text-xl font-bold">{title}</h3>
      <ul className="mt-4 space-y-3">
        {items.map((t) => (
          <li key={t} className="flex gap-3 text-gray-700">
            <SafeIcon icon={icon} className={`mt-1 flex-none ${color}`} aria-hidden="true" />
            {t}
          </li>
        ))}
      </ul>
    </article>
  );
}

// Zielgruppen-Check
function AudienceFit() {
  return (
    <section className="bg-[#EEF2FF] py-16">
      <div className="mx-auto max-w-6xl px-4">
        <h2 className="text-3xl font-extrabold">Für wen ist dieses Buch geeignet?</h2>
        <div className="mt-8 grid gap-6 md:grid-cols-2">
          <Column title="Perfekt für dich, wenn …" items={fitYes} icon={FiCheck} color="text-green-600" />
          <Column title="Nicht geeignet, wenn …" items={fitNo} icon={FiX} color="text-[#D52B1E]" />
        </div>
      </div>
    </section>
  );
}

export default AudienceFit;